import { type Localisation } from "./en";

export const portugueseBrazilian: Localisation = {
  dateFormats: {
    currentDateFormat: "eee, do LLLL",
    currentTimeFormat: "HH:mm",
    dateDayMonth: "eeee do LLLL",
    hoursMinutes: "HH:mm",
    dateDay: "eeee do",
  },
  StatusProvider: {
    "Screen is active but no token is present":
      "A tela está ativa, mas nenhum token está presente",
    "Network error": "Erro de rede",
    "Checking display status": "Verificação do status do visor",
    "Failed to get display status": "Falha ao obter o status da tela",
    "Device ID: {{deviceId}}": "Device ID: {{deviceId}}",
    "If this issue persists, please contact your Teamworks administrator.":
      "Se o problema persistir, entre em contato com o administrador do Teamworks.",
    "This is usually due to a network error while setting up your device. Please reset your device using the button below and try again.":
      "Isso geralmente ocorre devido a um erro de rede ao configurar o dispositivo. Redefina o dispositivo usando o botão abaixo e tente novamente.",
    "Setup failed to complete": "A configuração não foi concluída",
    "Please reset your device using the button below and try again.":
      "Redefina o dispositivo utilizando o botão abaixo e tente novamente.",
  },
  ConfigProvider: {
    "Loading configuration": "Carregando configuração",
  },
  AppProvider: {
    Loading: "Carregamento",
    "No configuration selected": "Nenhuma configuração selecionada",
    "We could not find a configuration for the given code. Please contact your Teamworks administrator.":
      "Não foi possível encontrar uma configuração para o código fornecido. Entre em contato com o administrador do Teamworks.",
    "This device has been registered, but no configuration has been set yet. Dont worry, you can easily update this device in the digital displays management app.":
      "Este dispositivo foi registrado, mas nenhuma configuração foi definida ainda. Não se preocupe, você pode atualizar facilmente esse dispositivo no aplicativo de gerenciamento de displays digitais.",
    "Network error: failed to load playlist":
      "Erro de rede: falha ao carregar a lista de reprodução",
    "Device ID: {{deviceId}}": "Device ID: {{deviceId}}",
    "Resetting, please wait...": "Redefinindo, por favor aguarde...",
  },
  UpdatesProvider: {
    "Checking for update": "Verificação de atualização",
    "Downloading update": "Download da atualização",
  },
  InteractionScreen: {
    "Loading...": "Carregando...",
    "Press any key to begin": "Pressione qualquer tecla para começar",
    "No configurations assigned": "Nenhuma configuração atribuída",
    "You can assign a configuration or a playlist to run on this device in the Digital Displays management app.":
      "Você pode atribuir uma configuração ou uma lista de reprodução para ser executada nesse dispositivo no aplicativo de gerenciamento Digital Displays.",
  },
  SetupScreen: {
    "Scan the QR code on your camera app":
      "Digitalize o código QR no seu aplicativo de câmera",
  },
  TemplateScreen: {
    "Events page {{count}} of {{total}}":
      "Eventos página {{count}} de {{total}}",
    Today: "Hoje",
    "All day": "Todo o dia",
    Tomorrow: "Amanhã",
  },
  ErrorScreen: {
    "Something went wrong": "Algo deu errado",
    "Sorry for the inconvience, our engineers have been notified and will be working on a fix":
      "Desculpe pelo inconveniente, nossos engenheiros foram notificados e estarão trabalhando em uma correção",
    "If this issue persists, please contact your account manager":
      "Se o problema persistir, entre em contato com o gerente da sua conta",
    "Reset device": "Redefinir dispositivo",
    "Your IP address may need to be permitted: {{ip}}":
      "O seu endereço IP pode precisar ser permitido: {{ip}}",
    "The app will attempt to automatically reset in {{seconds}} seconds":
      "A aplicação tentará redefinir automaticamente em {{seconds}} segundos",
  },
  NextMatch: {
    days: "dias",
    hours: "horas",
    minutes: "minutos",
    seconds: "segundos",
  },
  MediaContentCarosel: {
    "Media not found": "Mídia não encontrada",
  },
  PlaylistProvider: {
    "Loading...": "Carregando...",
    "Loading playlist": "Carregando lista de reprodução",
  },
  ScreenFooter: {
    Hardcoded: "Codificado",
  },
  NotFoundLayout: {
    "Configuration not found": "Configuração não encontrada",
  },
  StrengthWorkoutBoard: {
    "No Workout Selected": "Nenhum treino selecionado",
    "Select a workout from the Digital Display tab in S&C to display it here":
      "Selecione um treino na aba Digital Display em S&C para exibi-lo aqui",
  },
  WeatherWidget: {
    "Weather unavailable": "Tempo indisponível",
  },
  NutritionMenu: {
    "Failed to fetch menu": "Falha ao buscar o menu",
  },
  NutritionDiningStation: {
    "Failed to fetch dining station":
      "Falha ao buscar a estação de alimentação",
    "Add ons will affect nutrition information":
      "Os complementos afetarão as informações nutricionais",
  },
  Weather: {
    Today: "Today",
    "No weather data to show, please contact your Teamworks administrator.":
      "Sem dados meteorológicos para exibir, entre em contato com o administrador do Teamworks.",
    Clear: "Céu limpo",
    Clouds: "Nublado",
    Rain: "Chuva",
    Drizzle: "Garoa",
    Thunderstorm: "Trovoada",
    Snow: "Neve",
    Mist: "Névoa",
    Smoke: "Fumaça",
    Haze: "Neblina",
    Dust: "Poeira",
    Fog: "Nevoeiro denso",
    Sand: "Areia",
    Ash: "Cinza vulcânica",
    Squall: "Rajada",
    Tornado: "Tornado",
  },
};
